import React from 'react';
import {Text} from '~/components/controls';
import PropTypes from 'prop-types';
const FuelText = ({style, fuel}) => {
  const fuelType = {
    gasoline: 'Benzine',
    diesel: 'Diesel',
    electric: 'Elektrisch',
    hybrid: 'Hybride',
    lng: 'LNG',
    lpg: 'LPG',
    other: 'Overig',
  }[fuel];

  return <Text style={style}>{fuelType}</Text>;
};
FuelText.propTypes = {
  style: PropTypes.any,
  fuel: PropTypes.any,
};



export default FuelText;
